import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

axiosInstance.interceptors.request.use(
  config => {
    config.headers['x-access-token'] = process.env.REACT_APP_API_KEY;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export const getProduits = async () => {
  try {
    const res = await axiosInstance.get(baseUrl + '/produits/produits');
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getProduitsSite = async () => {
  try {
    const res = await axiosInstance.get(baseUrl + '/produits/produitsSite');
    return res.data;
  } catch (err) {
    console.log(err);
  }
};
